// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"219":"fc2d4c48","223":"1ca3dc30","304":"2650238f","471":"adbf7d08","665":"f5739132","842":"943e3a33","845":"a29e00ce"}[chunkId] + ".chunk.js";
};